import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';

/**
 * A NavLink that inherits its colour from the rail. React Router adds the
 * `active` class; `MenuListItem` styles it, so this only clears the anchor
 * defaults.
 */
export const StyledNavLink = styled(NavLink)({
  textDecoration: 'none',
  color: 'inherit',
  '&:visited': {
    color: 'inherit',
  },
});
